import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sobre',
  templateUrl: './sobre.component.html',
  styleUrls: ['./sobre.component.scss'],
})
export class SobreComponent implements OnInit, AfterViewInit {
  sobre: any;
  displayAll = false;

  @ViewChild('expediente') element: ElementRef;
  isCollapsed: boolean;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.sobre = this.route.snapshot.data.sobre.expediente;
  }

  ngAfterViewInit() {

    // Eventos do icone de colapso.
    this.element.nativeElement.querySelectorAll('.toggle-collapsed').forEach((el: any) => {
      el.addEventListener('click', (e: Event) => {
        e.preventDefault();
        el.classList.toggle('open');
        document.getElementById(el.getAttribute('aria-controls'))?.classList.toggle('show');
      });
    });

    // Observa botão de expandir.
    const toggleButton = document.getElementById('toggle-btn');
    toggleButton.addEventListener('click', (e: Event) => {
      e.preventDefault();
      this.displayAll = !this.displayAll;

      const grupos = document.querySelectorAll('.collapse');
      grupos.forEach((el: any) => {
        if (this.displayAll) {
          el.classList.add('show');
          el.classList.add('in');
        } else {
          el.classList.remove('show');
          el.classList.remove('in');
        }
      });

      const toggles = document.querySelectorAll('a[data-toggle="collapse"]');
      toggles.forEach((el: Element) => {
        el.setAttribute('aria-expanded', this.displayAll ? 'true' : 'false');
      });

      toggleButton.innerText = this.displayAll ? 'Retrair todos' : 'Expandir todos';
    });
  }


}
